// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

Vue.config.productionTip = false;
Vue.config.performance = true;

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  components: { App },
  template: '<App />'
});





// WEBPACK FOOTER //
// ./src/main.js